
/* injects from baggage-loader */

'use strict';


// angular modules

global.vex = require('vex-js');

import 'jquery';

import 'angular';
import 'angular-ui-router';
import 'angular-ui-bootstrap';
import 'angular-growl-siter';
import '../../node_modules/angular-growl-siter/build/angular-growl.min.css';
import 'angular-ui-notification';
import '../../node_modules/angular-ui-notification/dist/angular-ui-notification.min.css';
import 'angular-ui-tree';
import 'angular-busy';
import 'angular-cookies';
import 'restangular';
import 'angular-contenteditable';
import 'angular-animate';
import 'angular-translate';
import 'angular-translate-loader-url';
import 'angular-dynamic-locale';
import 'angular-translate-storage-local';
import 'angular-translate-loader-static-files';


// common
import 'lodash';
import '../../node_modules/perfect-scrollbar/dist/css/perfect-scrollbar.css';
import '../../node_modules/perfect-scrollbar/dist/js/perfect-scrollbar.jquery.js';
import '../../node_modules/perfect-scrollbar/dist/js/perfect-scrollbar.js';


import 'swiper';
import 'lightbox2';
import 'responsive-nav';
import 'jquery-ui';
import 'jquery-datetimepicker';
import 'flipclock';
import '../../node_modules/flipclock/compiled/flipclock.css';


import 'ng-tags-input';

import '../../node_modules/ng-tags-input/build/ng-tags-input.css';


import 'ng-infinite-scroll';
import 'angular-ivh-treeview';
import '../../node_modules/angular-ivh-treeview/dist/ivh-treeview.css';



// WEBPACK FOOTER //
// ./src/app/index.vendor.js